import {useUniversalPost} from '#imports';
import {extractLink} from '~/helpers/api/ExtractLinkHelper';
import type {Profile} from '~/types/domain/Profile';

export type UpdateCategorizationRequest = {
    families: string[];
    categories: string[];
    categorySuggestion: string | null;
};

async function save(request: UpdateCategorizationRequest, profile: Profile): Promise<void> {
    const url = extractLink(profile.links, 'updateCategorization');
    return await useUniversalPost(url, {body: request});
}

export const categorizationRepository = {
    save,
};
